(() => {
  const init = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-testing-story]').forEach((story) => {
      const chapters = [...story.querySelectorAll('[data-story-chapter]')];
      chapters.forEach((chapter) => chapter.classList.add('is-visible'));
      if (reduced || !('IntersectionObserver' in window)) return;
      chapters.forEach((chapter) => chapter.classList.remove('is-visible'));
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold:.16, rootMargin:'0px 0px -8% 0px' });
      chapters.forEach((chapter) => observer.observe(chapter));
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once:true }) : init();
})();
